import ToolTip from "../../ToolTip/ToolTip";

export const deoLeadTableHeader=[
    { field: 'sl_no', headerName: 'Sl No', width: 80 },
    { field: 'lead_name', headerName: 'Student Name', width: 250 },
    { field: 'age', headerName: 'Age', width: 90 },
    { field: 'gender', headerName: 'Gender', width: 120 },
    { field: 'class_name', headerName: 'Class', width: 120 },
    { field: 'lead_place', headerName: 'Place', width: 120 },
    { field: 'lead_email_id', headerName: 'Email', width: 120 },
    { field: 'lead_syllabus_name', headerName: 'Syllabus', width: 150 },
    { field: 'lead_father_name', headerName: 'Parent Name', width: 250 },
    { field: 'lead_mob_no', headerName: 'Contact Number', width: 160 },
    { field: 'lead_whatsapp_no', headerName: 'Whatsapp Number', width: 160 },
    { field: 'type', headerName: 'Preferred Type', width: 160 },
    { field: "preferredName", headerName: 'Course Name/Club Name', width: 250 ,
        renderCell:({row})=>{
                    return row.lead_preffered_club?row.lead_preffered_club:row.lead_preffered_course_name;
                }
    },
    { field: 'program_name', headerName: 'Program Name', width: 220 },
    { field: 'Remarks', headerName: 'Remarks', width: 250 ,
                renderCell: (params) => {
                    return (
                        <ToolTip
                            expand={params.row.lead_remarks}
                            content={params.row.lead_remarks}
                        />
                    );
                },
    },
    {
        field: "lead_timestamp",
        headerName: "Created At",
        width: 200,
        renderCell: ({ value }) => {
          if (!value) return "";
      
          const date = new Date(value);
          const formattedDate = date.toISOString().split("T")[0]; // Extract YYYY-MM-DD
          const formattedTime = date.toLocaleString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          });
      
          return `${formattedDate} ${formattedTime}`;
        },
      }
      
      

]